import React from "react";
import InputGroup from "./input";

const FaqPage = () => {
  return (
    <div className="max-w-screen-xl mx-auto py-14">
      <section className="md:space-y-10 space-y-2 px-8 text-center">
        <h2 className="capitalize text-xl md:text-7xl font-semibold text-primary">
          Support
        </h2>
        <p className="font-light md:text-xl text-2xs">
          At SleengShort, we’re committed to providing exceptional support to
          ensure your experience with our platform is seamless. Whether you’re
          just getting started or need advanced technical assistance, our team
          is here to help.
        </p>
      </section>

      <section className="bg-[#B6DCFE] rounded-lg p-8 md:p-20 mt-10 md:mt-20 mx-6 md:mx-0">
        <header className="text-center mb-6 md:mb-14 space-y-2 md:space-y-4">
          <h2 className="font-semibold text-xl md:text-5xl">Reach out to Us</h2>
          <p className="font-light md:text-xl text-3xs">
            Our commitment to you goes beyond technology; it’s about delivering
            value, reliability, and innovation at every step. Here’s what you
            can expect from us
          </p>
        </header>

        <div className="flex md:flex-row flex-col justify-center gap-3 md:gap-6 px-12 md:px-0">
          {[
            {
              image: "/address.png",
              title: "Address",
              descr:
                " 4A, Olaide Omotoro Street off CIS road, off Amore, lekki, Lagos",
            },
            {
              image: "/email.png",
              title: "Email",
              descr: "Support@sleengshort.com",
            },
            {
              image: "/customer.png",
              title: "Customer Success",
              descr: "+234-811-4159-025",
            },
          ].map((item, i) => (
            <div
              key={i}
              className="text-center md:gap-4 w-full flex flex-col items-center"
            >
              <img
                src={"/about" + item.image}
                alt={item.title}
                className="w-[6.25rem] md:w-40 h-[6.25rem] md:h-40"
              />
              <p className="font-semibold text-base md:text-xl">{item.title}</p>
              <p className="text-2xs md:text-base">{item.descr}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="w-full flex justify-between flex-col md:flex-row gap-10 px-8 md:px-0 mt-20">
        <h3 className="text-2xl md:text-4xl font-medium">Leave us a message</h3>

        <form className="grid sm:grid-cols-1 gap-6">
          <InputGroup label="Name" placeholder="John Doe" />
          <InputGroup label="Email" placeholder="Email" />

          <div className="md:col-span-2">
            <label htmlFor="message" className="font-medium block mb-2">
              Message
            </label>
            <textarea
              id="message"
              placeholder="Type your message here..."
              className="bg-white rounded-lg p-2 focus:outline-none w-full h-32"
            ></textarea>
          </div>
          <div className="md:col-span-2 flex justify-end">
            <button className="w-full md:w-fit bg-primary text-white rounded-lg px-6 py-3 font-medium">
              Send message
            </button>
          </div>
        </form>
      </section>
    </div>
  );
};

export default FaqPage;
